import React from 'react'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import InputAdornment from '@material-ui/core/InputAdornment'

function FormTextField({
  visible,
  required,
  error,
  errorText,
  id,
  name,
  label,
  value,
  onChange,
  icon,
  autoComplete,
  maxLength,
  autoFocus,
  inputRef,
  inputComponent,
  placeholder,
  onFocus,
  outerClassName,
  innerClassName,
  gridSm = 6
}) {
  if (!visible) return null

  const inputProps = { startAdornment: icon ? <InputAdornment position="start">{icon}</InputAdornment> : undefined }
  if (inputComponent) inputProps.inputComponent = inputComponent
  if (maxLength) inputProps.maxLength = maxLength

  return (
    <Grid item xs={12} sm={gridSm} className={outerClassName}>
      <TextField
        autoFocus={autoFocus}
        inputRef={inputRef}
        id={id}
        name={name}
        label={label}
        placeholder={placeholder}
        onFocus={onFocus}
        value={value || ''}
        onChange={onChange}
        fullWidth
        autoComplete={autoComplete}
        required={required}
        error={Boolean(error)}
        helperText={error ? errorText : ''}
        className={innerClassName}
        InputProps={inputProps}
      />
    </Grid>
  )
}

export default FormTextField
